<div class="resources">
  <app-resources-list-component *ngIf="location" [location]="location"></app-resources-list-component>
</div>

